import register from './modules/register'

export default {
  register,
}



// WEBPACK FOOTER //
// ./src/store/register/index.js